 <div class="container-fluid h-100 p-0 m-0">
  <!-- <ngx-loading [show]="loading" ></ngx-loading> -->
  <app-generic-photo-gallery ></app-generic-photo-gallery>
</div>
<app-actionpanel></app-actionpanel>
